export enum FORMA_PAGO_TYPES {
    FP_HANDLE_CHANGE_FORM = 'FP_HANDLE_CHANGE_FORM',
    FP_HANDLE_ACTIVE_MODAL_ERROR = 'FP_HANDLE_ACTIVE_MODAL_ERROR',
    FP_HANDLE_ERRORS_FORM = 'FP_HANDLE_ERRORS_FORM',
    FP_HANDLE_SET_TOTAL_A_PAGAR = 'FP_HANDLE_SET_TOTAL_A_PAGAR',
    FP_HANDLE_SET_PAGOS = 'FP_HANDLE_SET_PAGOS',
    FP_HANDLE_SET_TABLE_PAGOS = 'FP_HANDLE_SET_TABLE_PAGOS',
    FP_HANDLE_SET_PAGO_COMPLETADO = 'FP_HANDLE_SET_PAGO_COMPLETADO',
    FP_RESTART_STATE = 'FP_RESTART_STATE'
}